<template>
  <div
    v-if="debugAllowed"
    class="wave-selector-fab"
    :class="{ 'is-expanded': isExpanded }"
    @mouseenter="expand"
    @mouseleave="collapse"
  >
    <!-- Floating action button trigger -->
    <div class="fab-trigger">
      <span class="fab-icon">⚙️</span>
    </div>

    <!-- Expandable content -->
    <div class="fab-content">
      <div class="wave-info">
        Vague : {{ $currentWave }} / {{ $maxWave }}
      </div>
      <div class="wave-controls">
        <input
          v-model="waveValue"
          type="range"
          min="1"
          step="1"
          :max="$maxWave"
          class="wave-slider"
        >
        <div class="wave-labels">
          <span>1</span>
          <span>{{ $maxWave }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'WaveSelector',
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    debugAllowed() {
      // Always disable debug on production domains
      const hostname = window.location.hostname;
      if (hostname === 'www.monnaiedeparis.fr' || hostname === 'monnaiedeparis.fr') {
        return false;
      }
      if (window.location.hostname !== 'localhost' && this.$store.state.attributes.wave === undefined) {
        return false;
      }
      if (window.location.hostname === 'localhost') {
        return true;
      }
      return this.$store.state.attributes.waveDebugger === true;
    },
    waveValue: {
      get() {
        return this.$store.getters.getCurrentWave;
      },
      set(value) {
        this.$store.commit('setCurrentWave', parseInt(value, 10));
      },
    },
  },
  methods: {
    expand() {
      this.isExpanded = true;
    },
    collapse() {
      this.isExpanded = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.wave-selector-fab {
  position: fixed;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fab-trigger {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  margin: 0 auto;
  opacity: 0.7

  .fab-icon {
    font-size: 20px;
    color: white;
    display: block;
    line-height: 20px;
    transform: translateY(2px);
  }
}

.fab-content {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%) translateY(20px);
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-width: 200px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.06);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
  }
}

.wave-info {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wave-controls {
  .wave-slider {
    width: 100%;
    height: 6px;
    border-radius: 3px;
    background: #e1e5e9;
    outline: none;
    appearance: none;
    margin-bottom: 8px;
    cursor: pointer;

    &::-webkit-slider-thumb {
      appearance: none;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: linear-gradient(135deg, #718096 0%, #4a5568 100%);
      cursor: pointer;
      border: 2px solid white;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: all 0.2s ease;

      &:hover {
        transform: scale(1.1);
      }
    }

    &::-moz-range-thumb {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: linear-gradient(135deg, #718096 0%, #4a5568 100%);
      cursor: pointer;
      border: 2px solid white;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }
  }
}

.wave-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #666;
  font-weight: 500;
}

// Expanded state
.wave-selector-fab.is-expanded {
  transform: translateX(-50%) translateY(-30px);
  .fab-content {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }

  .fab-trigger {
    opacity: 1;
    background: rgba(0, 0, 0, 0.7);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .wave-selector-fab {
    bottom: 20px;
  }

  .fab-content {
    min-width: 180px;
    padding: 14px 16px;
  }
}
</style>
